// Explore-stats page: Parliamentarians who changed parties.
// Recreates the Handbook page — a Gantt timeline of each party-changer's
// career plus party-changes-per-year, with a party-history table.

import React, { useState, useEffect } from 'react';
import { Paper, Typography } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import GanttTimeline from './GanttTimeline';
import { StatLine } from './charts';

export default function ChangedParties() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('changed-parties');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const charts = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Parliamentarians who changed parties"
      description={`Parliamentarians who represented more than one party${
        charts.total ? ` (${charts.total})` : ''
      } — party creations, renames, mergers and splits, and members who became independents.`}
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="changed-parties"
    >
      {data && (
        <>
          <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Parliamentarians who changed parties
            </Typography>
            <GanttTimeline items={charts.timeline || []} />
          </Paper>
          <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>Party changes per year</Typography>
            <StatLine data={charts.changes_per_year || []} xKey="year"
                      keys={['changes']} />
          </Paper>
        </>
      )}
    </ExploreStatsPage>
  );
}
